import React from "react";
import "chart.js/auto";
import { motion } from "framer-motion";
import { Pie } from "react-chartjs-2";
import { data1, data2, data3, data4, options } from "./constants";
import "../styles/About.css";

function About({ theme }) { 
  return (
    <motion.div
      className="about__main"
      style={{
        backgroundColor: theme === "white" ? "white" : "black",
        color: theme === "white" ? "gray" : "gray",
      }}
      variants={{
        hidden: { opacity: 0, x: 75 },
        visible: { opacity: 1, x: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="about__heading">About Me</h1>

      <div
        className="about__text"
        style={{
          color: theme === "white" ? "gray" : "gray",
        }}
      >
        Hello there! I am Kamlesh Joshi, a Computer Science Engineer with a
        passion for data structures and algorithms.
        <br />
        <div className="about__elements">
          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              I recently graduated from Bipin Tripathi Kumaon Institute of
              Technology, Dwarahat, where I honed my skills and knowledge in
              Computer Science and Engineering.
            </p>
            <br />
          </div>
          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              My interests lie in Competitive Programming, Web Development, and
              Software Development.
            </p>
            <br />
          </div>
          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              {" "}
              I actively participate in competitive programming contests to
              challenge myself and continuously improve my problem-solving
              abilities.
            </p>
            <br />
          </div>
          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              {" "}
              Lately, I've been exploring web and software development, and I'm
              finding it really exciting.
            </p>
            <br />
          </div>
          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              Overall, I'm a curious and motivated person who loves technology,
              and I'm excited to see where my studies and interests will take
              me.
            </p>
            <br />
          </div>

          <div className="about__first">
            <div className="abt__icon">
              <svg
                className="svg-icon"
                fill={theme === "white" ? "gray" : "gray"}
                viewBox="0 0 20 20"
              >
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>
              {" "}
              If you're into tech too, I'd love to connect with you on LinkedIn!
            </p>
            <br />
          </div>
        </div>
      </div>

      {/*

            Recent Updates

    */}
      <h2 className="abt-me">
        <u>Recent Updates </u>✨
      </h2>

      <div className="recent__updates__about">
        <ul>
          <li>💻 Ex-SDE Intern at GeeksforGeeks (Feb 2023 - Apr 2023)</li>
          <li>
            💻 Ex-T.C.E Intern(C/C++) at GeeksforGeeks (Aug 2022 - Jan 2022){" "}
          </li>
        </ul>
      </div>

      <div className="recent__updates__about last_p">
        <h2 className="abt-me">
          <u>Things I am Currently Working on </u>🤩
        </h2>
        <ul>
          <li>Problem Solving</li>
          <li>M.E.R.N Stack</li>
        </ul>
      </div>

      {/*
  Technical Skills
      Skills
  */}
        <div className="recent__updates__about">
          <h2  className="abt-me">
            <u>Technical Skills</u>👨‍💻
          </h2>
          <ul>
            <li>
              <b> Frameworks & Libraries:</b> React.js, Next.js, Node.js, MongoDB,
              Express.js, react-semantic-ui ,Boostrap
            </li>
            <div className="chart">
              <div className="chart__main">
                <Pie data={data1} height={100} width={100} options={options} />
              </div>
            </div>
            <li>
              <b>Languages:</b> C++, C, JavaScript, Python, SQL, HTML, CSS, SaSS,
              Java
            </li>
            <div className="chart">
              <div className="chart__main">
                <Pie data={data2} height={100} width={100} options={options} />
              </div>
            </div>
            <li>
              <b>Developer Tools:</b> Ubuntu, Git, GitHub, VS Code, Sublime Text,
              Burpsuite, Postman, Jira, MySQL
            </li>
            <div className="chart">
              <div className="chart__main">
                <Pie data={data3} height={100} width={100} options={options} />
              </div>
            </div>
            <li>
              <b> Soft Skills:</b> Leadership, Teamwork & Collaboration, Public
              Speaking, Creative, Innovative, Adaptablity, Problem solving
            </li>
            <div className="chart">
              <div className="chart__main">
                <Pie data={data4} height={100} width={100} options={options} />
              </div>
            </div>
          </ul>
        </div>
    </motion.div>
  );
}

export default About;
